import React, { createContext, useReducer } from "react";
import { DwellFilterReducer } from "../reducer/DwellFilterReducer";

/*
    This is used to store filter context for dwell detailed view.
*/

export const DwellFilterContext = createContext();

const DwellFilterContextProvider = (props) => {
    let initialState = {
        packageType: [],
        packageScheduledDeliveryWindow: [],
        selectedPackageStatusListTile: [],
        selectedTile: [],
        data: {
            packageType: [],
            packageScheduledDeliveryWindow: [],
        }
    }

    const [viewModelFilter, filterDispatcher] = useReducer(DwellFilterReducer, initialState);
    return (
        <DwellFilterContext.Provider value={{viewModelFilter, filterDispatcher}}>
            {props.children}
        </DwellFilterContext.Provider>
    )
}

export default DwellFilterContextProvider


// WEBPACK FOOTER //
// ./src/commons/context/DwellFilterContext.js